

interface HomeCardTitleProps {
  title: string;
  description: string;
  isNeedShort: boolean;
  subtitle?: string;
}

const HomeCardTitle = ({title, description, subtitle, isNeedShort}: HomeCardTitleProps) => {
  
  return (
    <div className="" style={{ zIndex: 30 }}>
      <div className="font-bold text-white font-ubuntu text-[12px] sm:text-[15px] md:text-[17px]  mb-1">
      {title}
      </div>
      <div className="text-white/95 font-ubuntu font-light 
      text-[14px] sm:text-[15px] md:text-[16px] opacity-80 mb-2   leading-[126%] tracking-[0px] overflow-y-hidden">
        {subtitle ?? ""}
      </div>
        <div className={`text-white font-ubuntu font-light text-[12px] sm:text-[14px] md:text-[16px] opacity-80 mb-2 leading-[126%] tracking-[0px] overflow-y-hidden ${isNeedShort ? "max-h-[30px] sm:max-h-[35px] md:max-h-[58px]" : "max-h-[100px]"}`}>
          {description}
        </div>
    </div>
  )
}

export default HomeCardTitle
